export const currencyGetter = {
	"GTQ": "Q",
	"USD": "$",
};